module.exports = __webpack_public_path__ + "assets/img/301e-gm.svg";